import Mutations from '../../odata/mutations';

export default { ...new Mutations('customerServiceRating'), ...new Mutations('customerServiceRatings') };
